/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

/**
 * Applies the requestOptions() method of `interceptor` to the passed options. Since the
 * interceptor is possibly undefined but callers expect a value, handles that case.
 *
 * @param interceptor A RequestInterceptor that could not be defined.
 * @param requestOptions The options to pass to requestOptions().
 * @param url The url to pass to requestOptions().
 */
function requestInterceptorOptions(interceptor, requestOptions, url) {
  if (!interceptor || !interceptor.requestOptions) {
    return requestOptions;
  }
  return interceptor.requestOptions(requestOptions, url);
}
/**
 * Applies the response() method of `interceptor` to the passed options. Since the
 * interceptor is possibly undefined but callers expect a value, handles that case.
 *
 * @param interceptor A RequestInterceptor that could not be defined.
 * @param response The response to pass to response().
 */
function requestInterceptorResponse(interceptor, response) {
  if (!interceptor || !interceptor.response) {
    return response;
  }
  return interceptor.response(response);
}
var neverRetryStrategy = function neverRetryStrategy() {
  return false;
};

/**
 * Adds headers that are typically required to interact with TRP services.
 *
 * @param options
 */
function applyRequiredHeaders(options) {
  if (!options.headers) {
    options.headers = {};
  }
  options.headers['X-TRP-Requested-With'] = 'nitro-fetch';
  return options;
}
/**
 * Determines if the request should be made again based on the RetryStrategy
 * passed. Assumes there's always a RetryStrategy.
 *
 * @param retryStrategy
 * @param response
 * @param retryInfo
 */
function shouldRetry(retryStrategy, response, retryInfo) {
  return __awaiter(this, void 0, void 0, function () {
    var b;
    return __generator(this, function (_a) {
      b = retryStrategy(response, retryInfo);
      if (typeof b === 'boolean') {
        return [2 /*return*/, Promise.resolve(b)];
      }
      return [2 /*return*/, b];
    });
  });
}
/**
 * The builder itself follows a typical builder pattern where each public function (aside
 * from build) builds up state configuring how fetch works. build() returns a fetch-like
 * function that uses that state to configure the request before its passed on to the
 * real fetch library.
 */
var FetchBuilder = /** @class */function () {
  function FetchBuilder(fetch) {
    this.authenticationStrategy = null;
    this.retryStrategy = neverRetryStrategy;
    this.fetch = fetch;
  }
  /**
   * Returns a Fetcher built with the passed url and options. A Fetcher is just a function
   * that will execute the same fetch() every time it's called.
   *
   * @param url
   * @param options
   */
  FetchBuilder.prototype.buildFetcher = function (url, options) {
    var _this = this;
    // common headers are applied universally right now, if this is a problem it can be parameterized
    options = applyRequiredHeaders(options);
    return function () {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, requestInterceptorOptions(this.authenticationStrategy, options, url)];
            case 1:
              // as additional interceptors are implemented, this logic will probably be best served
              // by reducing over an ordered list
              options = _a.sent();
              return [4 /*yield*/, this.fetch(url, options)];
            case 2:
              response = _a.sent();
              response.log = options.log;
              return [2 /*return*/, requestInterceptorResponse(this.authenticationStrategy, response)];
          }
        });
      });
    };
  };
  /**
   * Executes the actual fetch using the configured fetch implementation, potentially
   * multiple times.
   *
   * @param fetcher
   * @param url
   * @param method
   * @param log
   */
  FetchBuilder.prototype.fetchWithRetry = function (fetcher, url, method, log) {
    return __awaiter(this, void 0, void 0, function () {
      var attempts, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            attempts = 0;
            _a.label = 1;
          case 1:
            attempts += 1;
            log === null || log === void 0 ? void 0 : log.info("[".concat(method || 'GET', "] fetch from ").concat(url, "."));
            return [4 /*yield*/, fetcher()];
          case 2:
            response = _a.sent();
            _a.label = 3;
          case 3:
            return [4 /*yield*/, shouldRetry(this.retryStrategy, response, {
              attempts: attempts,
              log: log
            })];
          case 4:
            if (_a.sent()) return [3 /*break*/, 1];
            _a.label = 5;
          case 5:
            return [2 /*return*/, response];
        }
      });
    });
  };
  /**
   * Returns a fetch-like function that can be used with real fetch options. The options
   * that would normally be passed to a fetch implementation (ex: node-fetch) are decorated
   * before being passed to the implementation.
   */
  FetchBuilder.prototype.build = function () {
    var _this = this;
    return function (url, options) {
      return __awaiter(_this, void 0, void 0, function () {
        var fetcher;
        return __generator(this, function (_a) {
          options = Object.assign({}, options);
          fetcher = this.buildFetcher(url, options);
          return [2 /*return*/, this.fetchWithRetry(fetcher, url, options.method, options.log)];
        });
      });
    };
  };
  /**
   * Configures an AuthenticationStrategy to be used with any fetch call returned from build().
   *
   * @param authenticationStrategy
   */
  FetchBuilder.prototype.withAuthStrategy = function (authenticationStrategy) {
    this.authenticationStrategy = authenticationStrategy;
    return this;
  };
  /**
   * Configures an RetryStrategy to be used with any fetch call returned from build().
   *
   * @param retryStrategy
   */
  FetchBuilder.prototype.withRetryStrategy = function (retryStrategy) {
    this.retryStrategy = retryStrategy;
    return this;
  };
  return FetchBuilder;
}();
/**
 * Initializes a fetch builder with the passed fetch implementation. Once
 * options are configured via the builder, build() should be called to return
 * a configured fetch-like function that uses the configured strategies.
 *
 * The generics are intended to be automatically inferred from the passed fetch
 * implementation, ensuring that what comes out of the builder is usable in the same way
 * as what's passed in.
 *
 * If a fetch implementation is not passed, the global fetch implementation is used, if
 * available.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * @param fetchImpl
 */
function initFetch(fetchImpl) {
  if (!fetchImpl && window.fetch) {
    // use global fetch as a default if available...the case is to avoid a type mismatch error which should not
    // be possible due to the above overloads
    // because fetch would not then be called on window (ex: window.fetch()), it needs to be bound
    // to window to be used as a bare function
    fetchImpl = window.fetch.bind(window);
  }
  if (!fetchImpl) {
    throw new Error('Missing required implementation of fetch. Add node-fetch or whatwg-fetch as a dependency, or pass a fetch implementation.');
  }
  return new FetchBuilder(fetchImpl);
}
var ConsoleLogger = {
  debug: function debug(msg) {
    return console.log(msg);
  },
  error: function error(msg, err) {
    return console.error(msg, err);
  },
  info: function info(msg) {
    return console.log(msg);
  },
  warn: function warn(msg) {
    return console.log(msg);
  }
};
var defaultStatusRetryStrategyOptions = {
  multiplier: 1,
  randomize: false,
  retryableStatuses: [[500, 599]]
};
/**
 * Returns true if the passed `status` matches any of the statuses configured when
 * the retry strategy was instantiated. Handles the logic of distinguishing between
 * a bare status and a status range.
 *
 * @param retryableStatuses
 * @param status
 */
function isRetryableStatus(retryableStatuses, status) {
  if (!status) {
    return false;
  }
  for (var _i = 0, retryableStatuses_1 = retryableStatuses; _i < retryableStatuses_1.length; _i++) {
    var retryableStatus = retryableStatuses_1[_i];
    if (Array.isArray(retryableStatus) &&
    // this is a status range (a pair)
    status >= retryableStatus[0] && status <= retryableStatus[1]) {
      return true;
    }
    // assume the status is just a number
    if (status === retryableStatus) {
      return true;
    }
  }
  return false;
}
/**
 * Retries in the configured way if the response's status matches any of the
 * configured retryable statuses.
 *
 * See StatusRetryStrategyOptions for how to configure.
 *
 * @param options
 */
function statusRetryStrategy(options) {
  var _a = Object.assign({}, defaultStatusRetryStrategyOptions, options),
    maxAttempts = _a.maxAttempts,
    multiplier = _a.multiplier,
    retryableStatuses = _a.retryableStatuses,
    randomize = _a.randomize,
    waitMs = _a.waitMs;
  return function (response, info) {
    var attempts = info.attempts,
      log = info.log;
    if (attempts >= maxAttempts || !isRetryableStatus(retryableStatuses, response.status)) {
      return false;
    }
    // wait should be:
    //   1st retry (attempts == 1): waitMs * 1 (multiplier^0)
    //   2nd retry (attempts == 2): waitMs * multiplier (multiplier^1)
    //   3rd retry (attempts == 3): waitMs * multiplier^2
    //   etc.
    var wait = waitMs * Math.pow(multiplier, attempts - 1);
    if (randomize) {
      // random float between 1 and 2
      wait *= Math.random() + 1;
    }
    log === null || log === void 0 ? void 0 : log.info("Status ".concat(response.status, " is retryable. Trying again after ").concat(wait, "ms."));
    return new Promise(function (resolve) {
      setTimeout(function () {
        return resolve(true);
      }, wait);
    });
  };
}
export { ConsoleLogger, initFetch, neverRetryStrategy, statusRetryStrategy };